import React from "react";
import green from "../../img/footer_icon/flink-green.png";
import blue from "../../img/footer_icon/flink-blue.png";
import brown from "../../img/footer_icon/flink-brown.png";
import orange from "../../img/footer_icon/flink-orange.png";
import "./Footer.scss";

function Footer() {
  return (
    <div className="Footer">
      <div className="Flink-container Footer__box">
        <div className="Footer__icon-box">
          <img src={blue} alt="flink-blue" />
          <img src={brown} alt="flink-brown" />
          <img src={orange} alt="flink-orange" />
        </div>
        <div className="Footer__contact-box">
          <div className="Footer__contact-box__left">
            <div>
              <p>
                <span>Email: </span>
                info@flinknederland.nl
              </p>
            </div>
            <div>
              <p>
                <span>Phone: </span>
                085 48 33 120
              </p>
            </div>
            <div>
              <p>
                <span>Address: </span>
                Spoorlaan 350 5038 CC Tilburg, Nl
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
